import React from 'react'
import { ArrayChecker } from '../array-checker'
import { TableRow } from './table-row'

const PartnerTable = ({data, onDelete, onEdit, noEdit, noDelete}) => {
  const handleDelete = (partner) => {
    if(partner.pkId){
      console.log('delete this partner:', partner.pkId, onDelete)
      if(typeof onDelete === 'function'){
        onDelete(partner.pkId)
      }
    } else if(partner.id){
      console.log('delete this partner:', partner.id, onDelete)
      if(typeof onDelete === 'function'){
        onDelete(partner.id)
      }
    }
  }

  return (
    <ArrayChecker data={data}>
      <table className="table table--striped">
        <tbody className="text-sm">
          { data.map((partner, index) => (
            <TableRow
              key={index}
              data={partner}
              onDelete={noDelete ? undefined : () => handleDelete(partner)}
              noEdit={noEdit}
              onEdit={noEdit ? undefined : () => onEdit(partner)}
            />
          )) }
        </tbody>
      </table>
    </ArrayChecker>
  )
}

export { PartnerTable }
